// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__3TT5f","colMin":"styles_colMin__3-jwo","colCheckbox":"styles_colCheckbox__1FlZW"};